<style src="./GroupHeader.scss"lang="scss"></style>
<template>
  <tr class="group-header">
    <th scope="row" class="header id"></th>
    <th class="header" colspan="5"></th>

    <!-- COST -->
    <th
      @click="toggleColumnView('costLab', 'costUnit', 'costTotal')"
      class="header group"
      colspan="3">
      <span class="title">CUSTO</span>
    </th>

    <!-- MAX PRICE -->
    <th
      @click="toggleColumnView('maxLab', 'maxUnit', 'maxTotal')"
      class="header group"
      colspan="4">
      <span class="title">PREÇO MÁXIMO</span>
    </th>

    <!-- ESTIMATED -->
    <th
      @click="toggleColumnView('estimatedUnit', 'estimatedTotal')"
      class="header group"
      colspan="3">
      <span class="title">ESTIMADO</span>
    </th>

    <!-- PROPOSAL -->
    <th
      @click="toggleColumnView('proposalUnit', 'proposalTotal')"
      class="header group"
      colspan="3">
      <span class="title">PROPOSTA</span>
    </th>

    <!-- MINIMUM -->
    <th
      @click="toggleColumnView('minimumUnit', 'minimumTotal')"
      class="header group"
      colspan="3">
      <span class="title">MÍNIMO</span>
    </th>

    <!-- RANKING -->
    <th
      @click="toggleColumnView('rankingDistributor', 'rankingLab', 'rankingUnit', 'rankingTotal')"
      class="header group"
      colspan="5">
      <span class="title distributor">RANKING</span>
    </th>
  </tr>
</template>

<script>
export default {
  name: 'GroupHeader',
  methods: {
    toggleColumnView (...columns) {
      this.$emit('toggle-column', columns)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/event-map/components/group-header/GroupHeader.vue